import React, {useState, useEffect, useRef} from 'react';
import './styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { updateUsuario } from '../../../../Mutations/Usuarios/metodos';
import { getUsuarios } from '../../../../Querys/Usuarios/metodos';
import { rgxPassword, rgxPhoneNumber } from '../../../../helpers/regexp';
import PopUpAlert from 'componentes/General/PopUps/PopUpAlerta';
import { Validaciones } from '@renedelangel/helpers';
const { trim } = Validaciones;


export default function PanelConfiguracionUsuario(props){

    const { usuario, token } = useSelector(state => state.login);

    const cleanState = {
        nombre:'', 
        empresa:'',
        puesto:'',
        telefono:'',
        user:'',
        password:'',
        confirmarPassword: '',
        correo:'',
        usuarioID: ''
    }

    const [state, setState] = useState({})

    const [openAlert, setOpenAlert] = useState(false);
    const [textoAlert, setTextoAlert] = useState({
        titulo: '',
        mensaje: ''
    })

    const [recargar, setRecargar] = useState(false);

    const nombreRef = useRef(null);
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmarpasswordRef = useRef(null);


    useEffect(()=>{

        async function ftEffect(){

            let datosUsuario = await getUsuarios({usuarioID: usuario.usuarioID}, token);
            
        setState(cleanState)
        setState({
            usuarioID: datosUsuario.usuarioID,
            nombre: datosUsuario.nombre,
            empresa: datosUsuario.empresa,
            puesto: datosUsuario.puesto,
            telefono: datosUsuario.telefono,
            user: datosUsuario.usuario,
            password: null,
            confirmarpassword: null,
            correo: datosUsuario.correo
        })
    }
    ftEffect();
    },[recargar]
    )


    let {usuarioID, nombre, empresa, puesto, telefono, user, password, correo, confirmarPassword} = state;


    function handleValidaciones({ nombre, user, telefono, password, confirmarPassword }) {

        let error = false;
        let validaciones = [{
            condicion: nombre === "",
            ref: nombreRef, keyError: "nombre",
            mensajeError: "Es necesario capturar un nombre correcto"
        },{
            condicion: !rgxPhoneNumber.test(telefono) || trim(telefono) === "",
            ref: usernameRef, keyError: "telefono",
            mensajeError: "Capture un télefono válido"
        },
         {
            condicion: password && !rgxPassword.test(password),
            ref: passwordRef, keyError: "password",
            mensajeError: "La estructura de la contraseña debe contener una letra mayúscula, una letra minúscula, un número, un caracter especial y de 8 a 30 caracteres"
        }, {
            condicion: password && (password !== confirmarPassword), ref: confirmarpasswordRef, keyError: "confirmarPassword",
            mensajeError: "La contraseña de confirmación no es igual a la contraseña capturada"
        }];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            

            if(condicion){
                
            setTextoAlert({
                titulo: '!Error!',
                mensaje: `${mensajeError}`
            })
            setOpenAlert(true);
            return error = true
            }

            });

        if (error) return error;

    }

    function ftActualizar() {
        async function actualizar() {
            try {

                let { usuarioID, user, nombre, puesto, empresa, password, confirmarPassword, telefono, correo } = state;

                let error = await handleValidaciones({ nombre, user, telefono, password, confirmarPassword });

                if (error) {
                    return error;
                }

                let cambio = await updateUsuario({
                    input: {
                        usuarioID,
                        usuario: user,
                        nombre,
                        password: password === "" ? null : password,
                        lada: null,
                        telefono,
                        correo: correo,
                        empresa,
                        puesto
                    }
                }, token);

                if (!cambio) throw new Error("Ocurrió un error al modificar tu información");

                setTextoAlert({
                    titulo: '!Éxito!',
                    mensaje: 'Se ha logrado actualizar sus datos'
                })
                setOpenAlert(true);
                setRecargar(!recargar);

            } catch ({ message }) {
                setTextoAlert({
                    titulo: '!Error!',
                    mensaje: `${message}`
                })
                setOpenAlert(true);
            }
        } return actualizar();
    }


    
    function handleChange(e) {
        const { name, value } = e.target;
        setState(prevState => {
            return {
                ...prevState,
                [name]: value
            };
        });
    }



    return(<>
    <div className='contenedorGeneralPanelConfiguracionUsuario'>
        <div className='contenedorInternoPanelConfiguracionUsuario'>
            
            <div className='primeraSeccionConfiguracion'>
                <h1>Datos personales</h1>

                <div className='formPanelConfiguracion'>
                    <h2>Nombre completo</h2>
                    <input type='input' value={nombre} name={'nombre'} onChange={(e) =>{handleChange(e)}}/>
                </div>
                <div className='formPanelConfiguracion'>
                    <h2>Empresa</h2>
                    <input type='input' value={empresa} name={'empresa'} onChange={(e) =>{handleChange(e)}}/>
                </div>
                <div className='formPanelConfiguracion'>
                    <h2>Puesto</h2>
                    <input type='input' value={puesto} name={'puesto'} onChange={(e) =>{handleChange(e)}}/>
                </div>
                <div className='formPanelConfiguracion'>
                    <h2>Telefono</h2>
                    <input type='input' value={telefono} name={'telefono'} onChange={(e) =>{handleChange(e)}}/>
                </div>
            </div>

            <div className='segundaSeccionConfiguracion'>
                <h1>Información de la cuenta</h1>

                <div className='formPanelConfiguracionSegundaSeccion'>
                    <h2>Usuario</h2>
                    <input type='input' value={user} name={'user'} onChange={(e) =>{handleChange(e)}}/>
                </div>
                <div className='formPanelConfiguracionSegundaSeccion'>
                    <h2>Nueva contraseña</h2>
                    <input type='password' value={password} name={'password'} onChange={(e) =>{handleChange(e)}}/>
                </div>
                <div className='formPanelConfiguracionSegundaSeccion'>
                    <h2>Confirmar contraseña</h2>
                    <input type='password' value={confirmarPassword} name={'confirmarPassword'} onChange={(e) =>{handleChange(e)}}/>
                </div>
                <div className='formPanelConfiguracionSegundaSeccion' disabled={true} unselectable={true}>
                    <h2>Correo</h2>
                    <input type='input' value={correo}/>
                </div>
            </div>

            <button className='c_button_actualizar_informacion' onClick = {() =>{ftActualizar()}}>
                Actualizar datos
            </button>
        </div>
    </div>

    {openAlert ? (
                <PopUpAlert
                    titulo={textoAlert.titulo}
                    mensaje={textoAlert.mensaje}
                    open={setOpenAlert}
                />
            ) : (
                <></>
            )}
    </>)
}